export const unitMapping: { [key: string]: string } = {
  kwh: "kWh",
  mj: "MJ",
  l: "liter",
  m3: "m3",
  kg: "kg",
};
